export default __webpack_public_path__ + "static/O0162-c554173e2621226ddc3586ecb5f42852.png";